import { render, staticRenderFns } from "./IRestore.vue?vue&type=template&id=12c4d10a&"
import script from "./IRestore.vue?vue&type=script&lang=ts&"
export * from "./IRestore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports